import React from 'react';
import styled, { css } from 'styled-components';
import { Classable, HasChildren, Shapeable } from '@shapeable/types';
import { breakpoints, theme } from '@shapeable/theme';
import { classNames } from '@shapeable/utils';
import { Page } from '@shapeable/gesda-types';
import { ContentEntityIntro, ContentTitle, EntityGrid } from '@shapeable/ui';
import { PageIntroductionCard } from './page-introduction-card';
import { includes, sortBy } from 'lodash';
import { ExplorerProvider } from '../providers/explorer-provider';
import { PageExplorerLayout, PageExplorerLayoutProps } from './page-explorer-layout';
const cls = classNames('page-explorer-parent-layout');

// -------- Types -------->

// -------- Props -------->

export type PageExplorerParentLayoutProps = Classable & HasChildren & PageExplorerLayoutProps & { 
  entity?: Page;
};

export const PageExplorerParentLayoutDefaultProps: Omit<PageExplorerParentLayoutProps, 'entity'> = {
  isAsideSticky: true,  
};

// -------- Child Component Props -------->

type ContainerProps = {

};

// -------- Styles -------->

const ContainerStyles = breakpoints({
  base: css`
    
  `,
});

const ViewStyles = breakpoints({
  base: css`
    padding-top: ${theme.UNIT(4)};
  `,
});



const SectionStyles = breakpoints({
  base: css`
    padding: ${theme.UNIT(6)} 0;

    &:first-child {
      padding-top: 0;
    }
  `,
});

const IntroStyles = breakpoints({
  base: css`
    font-size: ${18/16}em;
  `,
});

const ChildPagesStyles = breakpoints({
  base: css`
    padding: ${theme.UNIT(8)} 0;
  `,
});

const TitleStyles = breakpoints({
  base: css`
    font-size: ${21/12}em;
  `,
});

const TypePagesStyles = breakpoints({
  base: css`
    ${ChildPagesStyles}
  `,
});

const FooterStyles = breakpoints({
  base: css`
    
  `,
});


// -------- Components -------->

const My = {
  Container: styled(PageExplorerLayout)<ContainerProps>`${ContainerStyles}`,
    View: styled.div`${ViewStyles}`,
    Section: styled.section`${SectionStyles}`,
      Intro: styled(ContentEntityIntro)`${IntroStyles}`,
      ChildPages: styled(EntityGrid)`${ChildPagesStyles}`,

      Title: styled(ContentTitle)`${TitleStyles}`,
      TypePages: styled(EntityGrid)`${TypePagesStyles}`,

};

export const PageExplorerParentLayout: Shapeable.FC<PageExplorerParentLayoutProps> = (props) => {
  const { className, entity, ...rest } = props;

  const { children } = entity;

  const firstChildSlugs = (entity.children || []).reduce<String[]>((acc, child) => {
    const slug = (child.family && child.family.length && child.family[0].slug) || child.slug;
    return [ ...acc, slug ];
  }, []);
  
  const items = sortBy(children.filter(child => includes(firstChildSlugs, child.slug)), 'orderNumber');

  return (
  <ExplorerProvider>
    <My.Container
      className={cls.name(className)}
      entity={entity}
      {...rest}
      content={
        <My.View>
        <My.Section>
          <My.Intro entity={entity} />
          <My.ChildPages 
            items={items} 
            tabletAutoColumns={3} 
            desktopAutoColumns={3} 
            desktopLargeAutoColumns={4} 
            spacing={4} 
            card={PageIntroductionCard}
          />
        </My.Section>
        </My.View>
      }
    />
    </ExplorerProvider>
  )
};

PageExplorerParentLayout.defaultProps = PageExplorerParentLayoutDefaultProps;
PageExplorerParentLayout.cls = cls;